export default __webpack_public_path__ + "static/media/04.35463172.jpg";